//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import progressBar from './progress.vue';
export default {
  components: {
    progressBar
  },
  props: [],
  name: 'pic-list',
  data() {
    return {
      tipsPic: {
        live: './images/corner_mark1.png',
        online: './images/corner_mark2.png',
        underline: './images/corner_mark3.png'
      },
      listObj: {
        list: [
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: ['案例分析', '调解技巧'],
            length: '60',
            hasprocess: false,
            hastip: false,
            status: 'live'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            hasprocess: false,
            hastip: false,
            status: 'live'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '60',
            hasprocess: true,
            hastip: false,
            status: 'live'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '0',
            hasprocess: true,
            hastip: false,
            status: 'live',
            time: '1小时9分'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '100',
            hasprocess: true,
            hastip: false,
            status: 'live'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '100',
            hasprocess: false,
            hastip: true,
            status: 'live'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '100',
            hasprocess: false,
            hastip: true,
            status: 'online'
          },
          {
            title: '人民调解员身心与健康管理身心与健康管理',
            url: 'javascript:;',
            pic: './images/pic_01.jpg',
            name: '张晓丽',
            number: '5.0',
            tag: [],
            length: '100',
            hasprocess: false,
            hastip: true,
            status: 'underline'
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions([])
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
